import { VuexModule, Module, Mutation, Action, getModule } from 'vuex-module-decorators';
import store from '@/store'
import {
  supplierInfo
} from "@/api/supplier"

export interface UserState {
  isOpen: boolean;
  userInfo: any;
}

@Module({ dynamic: true, store, name: 'user' })
class User extends VuexModule implements UserState {
  public isOpen: boolean = false;
  public userInfo: any = null;
  public takeremind = true
  public psdEasy = false
  public contractType = null

  @Mutation
  private SET_USER_INFO(user_info: any) {
    this.userInfo = user_info;
  }
  @Mutation
  private SET_takeremind(type: any) {
    this.takeremind = type;
  }
  @Mutation
  private SET_psdEasy(type: any) {
    this.psdEasy = type;
  }
  @Mutation
  private SET_contract(type: any) {
    this.contractType = type;
  }

  @Action
  public setUserInfo(user_info: any) {
    this.SET_USER_INFO(user_info);
  }
  @Action
  public settakeremind(type: any) {
    // console.log(type,88)
    this.SET_takeremind(type);
  }
  @Action
  public setPsdEasy(type: any) {
    // console.log(type,88)
    this.SET_psdEasy(type);
  }
  @Action
  public setContractType(type: any) {
    return new Promise((r)=>{
      supplierInfo({}).then((res)=>{
        window.localStorage.setItem('ContractType',res.Result.ContractType)
        r(res)
      })
    })
  }
}

export const UserModule = getModule(User);